import React from "react";
import UnauthorizedPage from "../CustomUnauthorized/CustomUnauthorized";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("❌ Uncaught Error Boundary error:", error, errorInfo);
  }

  resetError = () => {
    //this.setState({ hasError: false, error: null });
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <UnauthorizedPage
          leftTitle="Something Went Wrong"
          leftMessage="An unexpected error occurred."
          rightTitle="Unexpected Application Error"
          rightMessage="We’re sorry.Something went wrong. Our team is working to resolve it.
Please refresh the page or try again later. If the problem persists, contact support."
          /*   
        Only uncomment for debugging purposes
        rightMessage={this.state.error?.message || "Please try again."} */
          actions={[
            {
              label: "Reload Page",
              onClick: this.resetError,
              variant: "filled",
            },
            {
              label: "Go Home",
              href: "/",
              variant: "outline",
            },
          ]}
        />
      );
    }

    return this.props.children;
  }
}
